import { lazy } from "react";
import { FormattedMessage } from "react-intl";

export const resumeRoute = {
    path: "/resume",
    auth: false,
    component: lazy(() => import("./index"))
};

export const resumeMenu = {
    key: 200,
    path: "/resume",
    label: <FormattedMessage id="menu_resume" />,
    // icon: <MenuIcon.EventMap className="icon" />,
    children: []
};
